import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9158 1.69189L10.4657 3.36611C10.1658 4.48198 10.1958 5.70339 10.5353 6.97023C11.5359 10.7045 15.3742 12.9206 19.1085 11.92C19.5545 11.8005 19.9781 11.6408 20.3765 11.4463L21.917 10.6941L21.8135 12.4053C21.7509 13.4388 21.4388 14.465 20.8944 15.5537L20.618 16.1065H14.6972L12 17.9064L9.30278 16.1065H2.82802L2.5242 15.3606C2.49436 15.2861 2.45367 15.1837 2.41062 15.0726C2.33366 14.8741 2.2203 14.5753 2.17011 14.388C0.740695 9.05338 3.90652 3.57001 9.24118 2.1406L10.9158 1.69189ZM1 18.1066H9.30278L12 19.9047L14.6972 18.1066H23V20.1066H15.3028L12 22.3084L8.69722 20.1066H1V18.1066Z"}}]};

const MoonFallFilled = Vue.extend<IconProps>({
  name: 'MoonFallFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'moon-fall-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MoonFallFilled;
